import axios from "axios";
// import swal from "sweetalert";

const axiosNoAuthInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

axiosNoAuthInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    // Handle 500 errors - redirect to dashboards landing if in dashboards area
    if (error.response && error.response.status === 500) {
      const currentPath = window.location.pathname;
      if (currentPath.includes('/dashboards/')) {
        console.error('500 error in dashboards area - redirecting to dashboards landing page');
        window.location.href = '/dashboards-landing';
        return Promise.reject(error);
      } else {
        window.location.href = '/error';
        return Promise.reject(error);
      }
    }

    // Handle authentication errors
    if (error.response && error.response.status === 401 && error.response.statusText === "Unauthorized") {
      localStorage.removeItem("accessToken");
      axiosNoAuthInstance.defaults.headers["Authorization"] = null;
    }

    // Handle 404 errors
    if (error.response && error.response.status === 404) {
      return null;
    }

    return Promise.reject(error);
  }
);

export default axiosNoAuthInstance;
